import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import CertificateActions from '../actions/CertificateActions';


const CertificateSource = {

    getCertificates() {
        return {
            remote(state, candidateId) {
                const query = '?candidate_id=' + candidateId;
                return new SingleObjectResource(DJ_CONST.API.certificateList + query).fetch();
            },

            success: CertificateActions.getCertificatesSuccess,
            error: CurrentUserActions.pageFault
        }
    }
};

class CertificateStore {
    constructor() {
        this.certificates = [];
        this.exportAsync(CertificateSource);
        this.bindActions(CertificateActions);
    }

    onGetCertificatesSuccess(certificates) {
        this.setState({certificates})
    }
}

export default createStore(CertificateStore, 'CertificateStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/CertificateStore.js
 **/